
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-f67ce25e\",\"scoped\":true,\"hasInlineConfig\":false}!@../../../static/css/dialogEntry.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./crmVisitorDetailsDialog.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f67ce25e\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./crmVisitorDetailsDialog.vue"),
  /* scopeId */
  "data-v-f67ce25e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/crmDialog/crmVisitorDetailsDialog.vue
// module id = 1740
// module chunks = 0